import Page from 'src/components/molecules/page';
import { Container } from '@mui/material';
import { FC } from 'react';

import { CustomerReservationCancel } from 'src/components/organisms/customer-reservation/cancel';

export const CustomerReservationCancelPage: FC = () => {
  /* 定数宣言 */
  const title = '予約キャンセル';

  return (
    <Page title={title}>
      <Container maxWidth={false}>
        <CustomerReservationCancel />
      </Container>
    </Page>
  );
};
